import React from "react";
import { useRouteMatch } from "react-router";
import { Route, Switch } from "react-router-dom";
import { PreloadedRoute } from "../app/PreloadedRoute";

import { PrivacyNoticeView } from "../container/ML/PrivacyNotice";
import { ComplianceOfficer } from "../container/ML/ComplianceOfficer";
import { ComplianceOfficerNo } from "../container/ML/ComplianceOfficerNo"; 
import { HasRoleRjsc } from "../container/ML/HasRoleRjsc";
import { ChooseNewComplianceOfficier } from "../container/ML/ChooseNewComplianceOfficer";
import { IsResidentOfCanada } from "../container/ML/IsResidentOfCanada";
import { IsResidentCanadaNo } from "../container/ML/IsResidentCandaNo";
import { IsNineteen } from "../container/ML/IsNineteen";
import { IsNineteenNo } from "../container/ML/IsNineteenNo";
import ApplyForMortgageLenderLicenceView from "../container/ML/ApplyForMortgageLenderLicence";
import LenderNextSteps from "../container/ML/LenderNextSteps";
import { CompanyContactInformation } from "../container/ML/CompanyContactInformation";
import { SelectTypeCompany } from "../container/ML/SelectTypeCompany";
import { IsBuisnessCorporated } from "../container/ML/IsBusinessCorporated";
import { BusinessNotEligible } from "../container/ML/BusinessNotEligible";
import { IsBusinessUnderLaw } from "../container/ML/IsBusinessUnderLaw";
import { SelectLender } from "../container/ML/SelectLender";
import { LenderContactInformation } from "../container/ML/LenderContactInformation";
import { CompanyFinancialLocation } from "../container/ML/CompanyFinancialLocation";
import { CompanyFiscalEndDate } from "../container/ML/CompanyFiscalEndDate";
import { AppointedAgentServiceAddress } from "../container/ML/AppointedAgentServiceAddress";
import { UploadCriminalRecordCheck } from "../container/ML/UploadCriminalRecordCheck";
import { UploadProofOfInsurance } from "../container/ML/UploadProofOfInsurance";
import { LenderConfirmation } from "../container/ML/LenderConfirmation";
import { LenderApplicationReview } from "../container/ML/LenderApplicationReview";

import { PrivacyNoticeView as MAPrivacyNoticeView } from "../container/ML/MA/PrivacyNotice";
import { ComplianceOfficer as MAComplianceOfficer } from "../container/ML/MA/ComplianceOfficer";
import { ComplianceOfficerNo as MAComplianceOfficerNo } from "../container/ML/MA/ComplianceOfficerNo"; 
import { HasRoleRjsc as MAHasRoleRjsc } from "../container/ML/MA/HasRoleRjsc";
import { ChooseNewComplianceOfficier as MAChooseNewComplianceOfficier } from "../container/ML/MA/ChooseNewComplianceOfficer";
import { IsResidentOfCanada as MAIsResidentOfCanada } from "../container/ML/MA/IsResidentOfCanada";
import { IsResidentCanadaNo as MAIsResidentCanadaNo } from "../container/ML/MA/IsResidentCandaNo";
import { IsNineteen as MAIsNineteen } from "../container/ML/MA/IsNineteen";
import { IsNineteenNo as MAIsNineteenNo } from "../container/ML/MA/IsNineteenNo";
import ApplyForMortgageAdminLicenceView from "../container/ML/MA/ApplyForMortgageAdminLicence";
import { SelectTypeCompany as MASelectTypeCompany } from "../container/ML/MA/SelectTypeCompany";
import { IsBuisnessCorporated as MAIsBuisnessCorporated } from "../container/ML/MA/IsBusinessCorporated";
import { BusinessNotEligible as MABusinessNotEligible } from "../container/ML/MA/BusinessNotEligible";
import { IsBusinessUnderLaw as MAIsBusinessUnderLaw } from "../container/ML/MA/IsBusinessUnderLaw";
import { TrustAccount } from "../container/ML/MA/TrustAccount";
import { ConfrimSuretyBond } from "../container/ML/MA/SuretyBond"

import Navigation from "../container/Navigation";
import { APPLICATION_TYPE_MORTGAGE_LENDER_LICENCE, ROUTE_PATH } from "./constants";
import MLRJSCSearch from "../container/ML/MLRJSCSearch";
import MLRJSCSearchResult from "../container/ML/MLRJSCSearchResult";
import MLRJSCDetailReview from "../container/ML/MLRJSCDetailReview";
import MLRJSCCompanyDetail from "../container/ML/MLRJSCCompanyDetail";
import MLRJSCAdvanceSearchResult from "../container/ML/MLRJSCAdvanceSearchResult";
import MLPaymentPreview from "../container/ML/MLPaymentPreview";
// import { MraRJSCEnterCompanyInfo } from "../container/MRA/MraRJSCEnterCompanyInfo";
// import { MraRJSCEnterCompanyOfficals } from "../container/MRA/MraRJSCEnterCompanyOfficals";
import { MLPaymentConfirmation } from "../container/ML/MLPaymentConfirmation";
import { MraRJSCEnterCompanyInfo } from "../container/MRA/MraRJSCEnterCompanyInfo";
import { MraRJSCEnterCompanyOfficals } from "../container/MRA/MraRJSCEnterCompanyOfficials";
import { RenewalComplianceOfficerInformation } from "../container/ML/Renewal/RenewalComplianceOfficerInformation";
import { RenewalComplianceOfficerQualification } from "../container/ML/Renewal/RenewalComplianceOfficerQualification"
import { RenewalRegulationAct } from "../container/ML/Renewal/RenewalRegulationAct"
import { ConfirmAIRSubmission } from "../container/MRA/Renewals/ConfirmAIRSubmission"
import { RenewalCompanyType } from "../container/ML/Renewal/RenewalCompanyType"
import { RenewalCompanyFiscalEndDate } from "../container/ML/Renewal/RenewalCompanyFiscalEndDate"
import { RenewalCompanyFinancialLocation } from "../container/ML/Renewal/RenewalCompanyFinancialLocation"
import { RenewalAppointedAgentServiceAddress } from "../container/ML/Renewal/RenewalAppointedAgentServiceAddress"
import { RenewalProofOfInsurance } from "../container/ML/Renewal/RenewalProofOfInsurance"
import { RenewalCriminalRecordCheck } from "../container/ML/Renewal/RenewalCriminalRecordCheck";
import { RenewalApplicationReview } from "../container/ML/Renewal/RenewalApplicationReview";
import RenewalConfirmBeforePayment from "../container/ML/Renewal/RenewalConfirmBeforePayment";
import RenewalPaymentPreview from "../container/ML/Renewal/RenewalPaymentPreview";
import { RenewalPaymentConfirmation } from "../container/ML/Renewal/RenewalPaymentConfirmation";
import { RenewalSelectLender } from "../container/ML/Renewal/RenewalSelectLender";

export const LenderApp = (props) => {
  let { path } = useRouteMatch();

  return (
    <>
      <Navigation {...props} applicationType={APPLICATION_TYPE_MORTGAGE_LENDER_LICENCE} />
      <Switch>
        <Route
          path={`${path}${ROUTE_PATH.ML_PRIVACY_NOTICE}`}
          component={PrivacyNoticeView}
        />
        <Route
          path={`${path}${ROUTE_PATH.MA_PRIVACY_NOTICE}`}
          component={MAPrivacyNoticeView}
        />
        <Route
          path={`${path}${ROUTE_PATH.ML_IS_COMPLIANCE_OFFICER}`}
          component={ComplianceOfficer}
        />
        <Route
          path={`${path}${ROUTE_PATH.MA_IS_COMPLIANCE_OFFICER}`}
          component={MAComplianceOfficer}
        />
        <Route
          path={`${path}${ROUTE_PATH.ML_IS_COMPLIANCE_OFFICER_NO}`}
          component={ComplianceOfficerNo}
        />
        <Route
          path={`${path}${ROUTE_PATH.MA_IS_COMPLIANCE_OFFICER_NO}`}
          component={MAComplianceOfficerNo}
        />
        <Route
          path={`${path}${ROUTE_PATH.ML_HAS_ROLE_WITH_RJSC}`}
          component={HasRoleRjsc}
        />
        <Route
          path={`${path}${ROUTE_PATH.MA_HAS_ROLE_WITH_RJSC}`}
          component={MAHasRoleRjsc}
        />
        <Route
          path={`${path}${ROUTE_PATH.ML_CHOOSE_NEW_COMPLIANCE_OFFICER}`}
          component={ChooseNewComplianceOfficier}
        />
        <Route
          path={`${path}${ROUTE_PATH.MA_CHOOSE_NEW_COMPLIANCE_OFFICER}`}
          component={MAChooseNewComplianceOfficier}
        />
        <Route
          path={`${path}${ROUTE_PATH.ML_IS_RESIDENT_CANADA}`}
          component={IsResidentOfCanada}
        />
        <Route
          path={`${path}${ROUTE_PATH.MA_IS_RESIDENT_CANADA}`}
          component={MAIsResidentOfCanada}
        />
        <Route
          path={`${path}${ROUTE_PATH.ML_IS_RESIDENT_CANADA_NO}`}
          component={IsResidentCanadaNo}
        />
        <Route
          path={`${path}${ROUTE_PATH.MA_IS_RESIDENT_CANADA_NO}`}
          component={MAIsResidentCanadaNo}
        />
        <Route
          path={`${path}${ROUTE_PATH.ML_IS_NINETEEN}`}
          component={IsNineteen}
        />
         <Route
          path={`${path}${ROUTE_PATH.MA_IS_NINETEEN}`}
          component={MAIsNineteen}
        />
        <Route
          path={`${path}${ROUTE_PATH.ML_IS_NINETEEN_NO}`}
          component={IsNineteenNo}
        />
         <Route
          path={`${path}${ROUTE_PATH.MA_IS_NINETEEN_NO}`}
          component={MAIsNineteenNo}
        />
        <Route
          path={`${path}${ROUTE_PATH.ML_APPLY_LENDER_LICENCE}`}
          component={ApplyForMortgageLenderLicenceView}
        />
        <Route
          path={`${path}${ROUTE_PATH.MA_APPLY_ADMIN_LICENCE}`}
          component={ApplyForMortgageAdminLicenceView}
        />
        <Route
          path={`${path}${ROUTE_PATH.ML_SELECT_COMPANY_TYPE}`}
          component={SelectTypeCompany}
        />
        <Route
          path={`${path}${ROUTE_PATH.MA_SELECT_COMPANY_TYPE}`}
          component={MASelectTypeCompany}
        />
        <Route
          path={`${path}${ROUTE_PATH.ML_IS_BUSINESS_INCORPORATED}`}
          component={IsBuisnessCorporated}
        />
        <Route
          path={`${path}${ROUTE_PATH.MA_IS_BUSINESS_INCORPORATED}`}
          component={MAIsBuisnessCorporated}
        />
        <Route
          path={`${path}${ROUTE_PATH.ML_IS_BUSINESS_UNDER_LAW}`}
          component={IsBusinessUnderLaw}
        />
        <Route
          path={`${path}${ROUTE_PATH.MA_IS_BUSINESS_UNDER_LAW}`}
          component={MAIsBusinessUnderLaw}
        />
        <Route
          path={`${path}${ROUTE_PATH.ML_BUSINESS_NOT_ELIGIBLE}`}
          component={BusinessNotEligible}
        />
        <Route
          path={`${path}${ROUTE_PATH.MA_BUSINESS_NOT_ELIGIBLE}`}
          component={MABusinessNotEligible}
        />
        <PreloadedRoute
          path={`${path}${ROUTE_PATH.ML_NEXT_STEPS}`}
          component={LenderNextSteps}
        />
        <PreloadedRoute
          path={`${path}${ROUTE_PATH.ML_RJSC_SEARCH}`}
          component={MLRJSCSearch}
        />
        <PreloadedRoute
          path={`${path}${ROUTE_PATH.ML_RJSC_SEARCH_SELECT}`}
          component={MLRJSCSearchResult}
        />
        <PreloadedRoute
          path={`${path}${ROUTE_PATH.ML_RJSC_DETAIL_REVIEW}`}
          component={MLRJSCDetailReview}
        />
        <PreloadedRoute
          path={`${path}${ROUTE_PATH.ML_RJSC_COMPANY_DETAIL}`}
          component={MLRJSCCompanyDetail}
        />
        <PreloadedRoute
          path={`${path}${ROUTE_PATH.ML_RJSC_OPERATING_NAME_SEARCH_SELECT}`}
          component={MLRJSCAdvanceSearchResult}
        />
        <PreloadedRoute
          path={`${path}${ROUTE_PATH.ML_RJSC_COMPANY_INFO}`}
          component={MraRJSCEnterCompanyInfo}
        />
        <PreloadedRoute
          path={`${path}${ROUTE_PATH.ML_RJSC_COMPANY_OFFICIALS}`}
          component={MraRJSCEnterCompanyOfficals}
        />
        <PreloadedRoute
          path={`${path}${ROUTE_PATH.ML_COMPANY_CONTACT_INFO}`}
          component={CompanyContactInformation}
        />
        <PreloadedRoute
          path={`${path}${ROUTE_PATH.ML_PAYMENT_PREVIEW}`}
          component={MLPaymentPreview}
        />
        <PreloadedRoute
          path={`${path}${ROUTE_PATH.ML_PAYMENT_CONFIRMATION}`}
          component={MLPaymentConfirmation}
        />
        <PreloadedRoute
          path={`${path}${ROUTE_PATH.ML_SELECT_LENDER}`}
          component={SelectLender}
        />
        <PreloadedRoute
          path={`${path}${ROUTE_PATH.ML_LENDER_CONTACT_INFORMATION}`}
          component={LenderContactInformation}
        />
        <PreloadedRoute
          path={`${path}${ROUTE_PATH.ML_COMPANY_FINANCIAL_LOCATION}`}
          component={CompanyFinancialLocation}
        />
        <PreloadedRoute
          path={`${path}${ROUTE_PATH.ML_FISCAL_END_DATE}`}
          component={CompanyFiscalEndDate}
        />
        <PreloadedRoute
          path={`${path}${ROUTE_PATH.ML_AGENT_ADDRESS}`}
          component={AppointedAgentServiceAddress}
        />
        <PreloadedRoute
          path={`${path}${ROUTE_PATH.ML_UPLOAD_CRIMINAL_RECORD_CHECK}`}
          component={UploadCriminalRecordCheck}
        />
        <PreloadedRoute
          path={`${path}${ROUTE_PATH.ML_UPLOAD_PROOF_OF_INSURANCE}`}
          component={UploadProofOfInsurance}
        />
        <PreloadedRoute
          path={`${path}${ROUTE_PATH.ML_CONFIRMATION}`}
          component={LenderConfirmation}
        />
        <PreloadedRoute
          path={`${path}${ROUTE_PATH.ML_APPLICATION_REVIEW}`}
          component={LenderApplicationReview}
        />
        <PreloadedRoute
          path={`${path}${ROUTE_PATH.MA_TRUST_ACCOUNT}`}
          component={TrustAccount}
        />
        <PreloadedRoute
          path={`${path}${ROUTE_PATH.MA_SURETY_BOND}`}
          component={ConfrimSuretyBond}
        />
         <PreloadedRoute
          path={`${path}${ROUTE_PATH.RENEWAL_SELECT_LENDER}`}
          component={RenewalSelectLender}
        />
        <PreloadedRoute
          path={`${path}${ROUTE_PATH.RENEWAL_COMPLIANCE_OFFICER}`}
          component={RenewalComplianceOfficerInformation}
        />
        <PreloadedRoute
          path={`${path}${ROUTE_PATH.RENEWAL_COMPLIANCE_OFFICER_QUALIFICATION}`}
          component={RenewalComplianceOfficerQualification}
        />
        <PreloadedRoute
          path={`${path}${ROUTE_PATH.RENEWAL_REGULATION_ACT}`}
          component={RenewalRegulationAct}
        />
        <PreloadedRoute
          path={`${path}${ROUTE_PATH.RENEWAL_AIR_SUBMISSION}`}
          component={ConfirmAIRSubmission}
        />
        <PreloadedRoute
          path={`${path}${ROUTE_PATH.RENEWAL_COMPANY_TYPE}`}
          component={RenewalCompanyType}
        />
        <PreloadedRoute
          path={`${path}${ROUTE_PATH.RENEWAL_COMPANY_FISCAL_END_DATE}`}
          component={RenewalCompanyFiscalEndDate}
        />
        <PreloadedRoute
          path={`${path}${ROUTE_PATH.RENEWAL_COMPANY_FINANCIAL_RECORDS_LOCATION}`}
          component={RenewalCompanyFinancialLocation}
        />
        <PreloadedRoute
          path={`${path}${ROUTE_PATH.RENEWAL_APPOINTED_AGENT_SERVICE_ADDRESS}`}
          component={RenewalAppointedAgentServiceAddress}
        />
        <PreloadedRoute
          path={`${path}${ROUTE_PATH.RENEWAL_PROOF_OF_INSURANCE}`}
          component={RenewalProofOfInsurance}
        />
        <PreloadedRoute
          path={`${path}${ROUTE_PATH.RENEWAL_CRIMINAL_RECORD_CHECK}`}
          component={RenewalCriminalRecordCheck}
        />
        <PreloadedRoute
          path={`${path}${ROUTE_PATH.RENEWAL_APPLICATION_REVIEW}`}
          component={RenewalApplicationReview}
        />
        <PreloadedRoute
          path={`${path}${ROUTE_PATH.RENEWAL_CONFIRMATION_BEFORE_PAYMENT}`}
          component={RenewalConfirmBeforePayment}
        />
        <PreloadedRoute
          path={`${path}${ROUTE_PATH.RENEWAL_PAYMENT_PREVIEW}`}
          component={RenewalPaymentPreview}
        />
        <PreloadedRoute
          path={`${path}${ROUTE_PATH.RENEWAL_PAYMENT_CONFIRMATION}`}
          component={RenewalPaymentConfirmation}
        />
      </Switch>
    </>
  );
};
